import React from 'react'
import { clsx } from 'clsx'
import { bodyWrapperVariants } from '../styles'

const { bodyWrapper } = bodyWrapperVariants()

const BodyWrapper = ({ children, className }: any) => <div className={clsx(bodyWrapper(), className)}>{children}</div>

export default BodyWrapper
